// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"e99386a8","90":"01ead8a5","323":"a35be6f5","552":"b7d8500b","719":"31d6cfe0","770":"e99386a8","780":"a6b023dc","815":"1b706d5b"}[chunkId] + ".chunk.css";
};